<template>
  <div>
    <v-snackbar
      v-model="snackbarMsgStatus"
      top
      dense
      :color="options.color"
      class="pa-12 mt-0 mt-n8 black--text snackbar-zIndex"
      :timeout="5000"
      :class="options.classes"
      max-width="600px"
      @input="inputHandler"
    >
      <v-row class="py-0">
        <v-col cols="auto" class="pr-0" align="left">
          <v-icon :color="options.icon.color">
            {{ options.icon.code }}
          </v-icon>
        </v-col>
        <v-col class="pl-2" :class="options.class">
          <h3 class="subtitle-2">{{ snackbar.title }}</h3>
          <span
            class="text-justify break-word body-2"
            v-html="snackbar.message"
          ></span>
        </v-col>
        <v-col
          cols="auto"
          class="pa-0"
          v-if="snackbar.type !== 'warning_two'"
          align="right"
        >
          <v-btn
            text
            icon
            :class="options.class"
            class="ml-0 mt-1"
            v-track="'close-snackbar'"
            @click="close"
          >
            <v-icon size="20"> close </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "GlobalSnackbar",
  data() {
    return {
      snackbarValue: true,
    };
  },
  computed: {
    snackbarMsgStatus: {
      get() {
        return this.$store.getters["ui/snackbar"].show;
      },
      set(value) {
        this.$store.commit("ui/snackbar.show", value);
      },
    },

    options() {
      let options = {
        icon: {
          code: "",
          color: "",
        },
        class: "",
        color: "blue lighten-4",
        textcolor: "white",
        classes: {
          success_status: false,
          error_status: false,
          warning_status: false,
          warning_two_status: false,
        },
      };
      switch (this.$store.getters["ui/snackbar"].type) {
        case "success":
          options.color = "green lighten-4";
          options.icon.code = "mdi-check-circle-outline";
          options.icon.color = "green";
          options.class = "success-snackbar";
          options.classes.success_status = true;
          break;
        case "error":
          options.icon.code = "error_outline";
          options.textcolor = "#000000";
          options.classes.error_status = true;
          options.color = "#f8dddc";
          options.class = "error-snackbar";
          options.icon.color = "#9E2020";
          break;
        case "warning":
          options.color = "#fff2cc";
          options.icon.code = "mdi-information-outline";
          options.icon.color = "#2F3643";
          options.classes.warning_status = true;
          break;
        default:
          options.color = "blue lighten-4";
      }
      return options;
    },

    ...mapGetters({
      snackbar: ["ui/snackbar"],
    }),
  },
  mounted() {},
  methods: {
    close() {
      this.snackbarMsgStatus = false;
    },
    inputHandler() {
      if (!this.snackbarMsgStatus) {
        this.$store.dispatch("ui/snackbar.reset");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.error-snackbar,
.success-snackbar {
  color: #000 !important;
}
.v-snack__content {
  padding: 5px 15px !important;
}
.success_status .v-snack__content {
  border-color: #a5d6a7;
  color: black !important;
}
.warning_status .v-snack__content {
  border-color: #fff2cc;
}
.warning_two_status .v-snack__content {
  border-color: #fee28e;
}
.snackbar-zIndex {
  z-index: 9999 !important;
}
.cross-icon {
  color: #fff !important;
}
.break-word {
  word-break: break-word;
}
</style>
